var render = function render(_c,_vm){return _c('span',_vm._g(_vm._b({class:[_vm.data.class, _vm.data.staticClass, 'sf-chevron'],style:([_vm.data.style, _vm.data.staticStyle])},'span',_vm.data.attrs,false),_vm.listeners),[_vm._t("default",function(){return [_c('span',{staticClass:"sf-chevron__bar sf-chevron__bar--left"}),_c('span',{staticClass:"sf-chevron__bar sf-chevron__bar--right"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }